import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal, Row, Col, Input, Label } from 'reactstrap';
import CloseIcon from '../../images/close-button-white.png';
import {
  BANKTRANSFER,
  CREDITCARD,
  FULLWALLET,
} from '../../constants/paymentMethods';
import { TextRupiah }from '../Text';
import { Button } from '../Forms';

const ModalPaymentMethod = props => {
  return(
    <Modal
      // className="modal-cashout"
      modalClassName="modal-address"
      // wrapClassName="wrapper-search"
      // contentClassName="content-search"
      // backdropClassName="backdrop-checkout-content"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <div className="address-header">
        <div onClick={props.onToggle} className="icon-close">
          <KickImage className="btn-close-modal" src={CloseIcon} alt="close"/>
        </div>
        <div className="text-title">
          <p>{props.titleModal}</p>
        </div>
      </div>
      <div className="address-content">
        <div className="wrapper-border" style={{border: '1px solid #4a4a4a', padding: '1rem'}}>
          <div className="radio">
            <label>
              <input 
                type="radio" 
                name="_paymentType"
                value={BANKTRANSFER}
                checked={props._paymentType === BANKTRANSFER}
                onChange={props._handlePaymentTypeChange}
              /> Bank Transfer
            </label>
          </div>
          <div className="radio">
            <label>
              <input 
                type="radio" 
                name="_paymentType"
                value={CREDITCARD}
                checked={props._paymentType === CREDITCARD}
                onChange={props._handlePaymentTypeChange}
              /> Credit Card
            </label>
          </div>
          <div className="radio">
            <label>
              <input 
                type="radio" 
                name="_paymentType"
                value={FULLWALLET}
                checked={props._paymentType === FULLWALLET}
                onChange={props._handlePaymentTypeChange}
              /> Kick Credit
            </label>
          </div>
          <div style={{textAlign: 'right'}}>
            {/* <span>Balance: <TextRupiah prefix="IDR. " color="black" value={props._dataAuth.userdata.balance.toString()}/></span> */}
          </div>
        </div>
        <div className="details-payment" style={{marginTop: '1rem'}}>
          <Row style={{border: 0, marginBottom: '0rem', padding: '.5rem 1rem'}}>
            <Col>
              <span>Product Price</span>
            </Col>
            <Col>
              <span><TextRupiah prefix="IDR. " color="black" value={props.offerAmount.toString()}/></span>
            </Col>
          </Row>
          <Row style={{border: 0, marginBottom: '0rem', padding: '.5rem 1rem'}}>
            <Col>
              <span>Shipping and Handling</span>
            </Col>
            <Col>
              <span><TextRupiah prefix="IDR. " color="black" value={props.shippingFee.toString()}/></span>
            </Col>
          </Row>
          <Row style={{border: 0, marginBottom: '0rem', padding: '.5rem 1rem'}}>
            <Col>
              <span>Admin Fee</span>
            </Col>
            <Col>
              <span><TextRupiah prefix="IDR. " color="black" value={props._admFee().toString()}/></span>
            </Col>
          </Row>
          <Row style={{border: 0, marginBottom: '0rem', padding: '.5rem 1rem'}}>
            <Col>
              <span>TOTAL</span>
            </Col>
            <Col>
              <span><TextRupiah prefix="IDR. " color="black" value={props._getTotal().toString()}/></span>
            </Col>
          </Row>
          <Row style={{border: 0, marginBottom: '0rem', padding: '.5rem 1rem'}}>
            <Col style={{justifyContent: 'center'}}>
              <Button className="btn-black flat spacer" style={{    width: '100%', marginBottom: 0}} onClick={props.onToggle}>Submit</Button>
            </Col>
          </Row>
        </div>
      </div>
      {/* <div className="address-content">
        {
           paymentMethod.map((item, index) => {
             return(
              <Row key={index}>
                <Col sm={6} md={8} lg={10}>
                  <p>{item.method}</p>
                </Col>
                <Col sm={6} md={4} lg={2} style={{cursor: 'pointer'}}>
                  <p onClick={() => props.selectedPayment(item)}>USE THIS</p>
                </Col>
            </Row>
             )
           })
        }
      </div> */}
    </Modal>
  )
}

export default ModalPaymentMethod;